import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5ac4e972"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "top"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("  ");

const _hoisted_3 = {
  class: "contact-us"
};
const _hoisted_4 = {
  class: "center-box"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, null, -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, null, -1));

const _hoisted_7 = ["innerHTML"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "border"
}, null, -1));

const _hoisted_9 = {
  class: "tit center_1200"
};
const _hoisted_10 = {
  class: "input-line"
};
const _hoisted_11 = {
  class: "send-btn"
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode("发送");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_About = _resolveComponent("About");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, [_ctx.route.query.oldName ? (_openBlock(), _createElementBlock("b", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => _ctx.goOnePath && _ctx.goOnePath(...args))
  }, _toDisplayString(_ctx.route.query.oldName) + "  > ", 1)) : _createCommentVNode("", true), _hoisted_2, _createElementVNode("b", null, _toDisplayString(_ctx.route.query.onlyName), 1)])]), _createElementVNode("h3", null, _toDisplayString(_ctx.route.query.onlyName), 1), _createElementVNode("h5", null, _toDisplayString(_ctx.route.query.subtitle), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_About), _createElementVNode("div", _hoisted_4, [_createElementVNode("header", null, [_hoisted_5, _createTextVNode(_toDisplayString(_ctx.companyData.name) + " ", 1), _hoisted_6]), _createElementVNode("div", {
    class: "text",
    style: {
      "margin-top": "17px"
    },
    innerHTML: _ctx.companyData.content
  }, null, 8, _hoisted_7), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form, {
    ref: "ruleFormRef",
    model: _ctx.ruleForm,
    rules: _ctx.rules,
    class: "demo-ruleForm",
    "status-icon": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_form_item, {
      prop: "name"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.ruleForm.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.ruleForm.name = $event),
        placeholder: "姓名"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "email"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.ruleForm.email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.ruleForm.email = $event),
        placeholder: "邮箱信息"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "phone"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.ruleForm.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.ruleForm.phone = $event),
        placeholder: "手机号码"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]), _createVNode(_component_el_form_item, {
      prop: "clientDemand"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        class: "textarea",
        modelValue: _ctx.ruleForm.clientDemand,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.ruleForm.clientDemand = $event),
        rows: 4,
        type: "textarea",
        placeholder: "请输入您的反馈或建议"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
        onClick: _cache[5] || (_cache[5] = $event => _ctx.sendForm(_ctx.ruleFormRef))
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"])])])])], 64);
}